// One-time Firestore seed: populates collections from staticData if empty.
// All operations are wrapped defensively so permission failures (e.g. non-admin
// users landing on /admin before rules are published) never throw to the UI.
import { collection, getDocs, query, limit as fsLimit, doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/config";
import { products as STATIC_PRODUCTS, artists as STATIC_ARTISTS, categories as STATIC_CATEGORIES, deliveryMethods as STATIC_DELIVERY } from "../data/staticData";

async function isEmpty(col) {
  try {
    const snap = await getDocs(query(collection(db, col), fsLimit(1)));
    return snap.empty;
  } catch (_e) { return false; }
}

async function safeSet(path, data) {
  try { await setDoc(doc(db, ...path), data); } catch (_e) { /* ignore — permission issue */ }
}

export async function seedFirestoreIfEmpty() {
  try {
    if (await isEmpty("categories")) {
      let order = 0;
      for (const c of STATIC_CATEGORIES) {
        await safeSet(["categories", c.id], {
          name: c.name, slug: c.slug, description: c.description || "",
          image_url: c.image_url || "", parent_id: null, order: order++,
          created_at: serverTimestamp(), updated_at: serverTimestamp(),
        });
      }
    }
    if (await isEmpty("artists")) {
      for (const a of STATIC_ARTISTS) {
        await safeSet(["artists", a.id], {
          name: a.name, slug: a.slug, bio: a.bio || "",
          image_url: a.image_url || "", featured: !!a.featured,
          created_at: serverTimestamp(), updated_at: serverTimestamp(),
        });
      }
    }
    if (await isEmpty("products")) {
      for (const p of STATIC_PRODUCTS) {
        await safeSet(["products", p.id], {
          title: p.title, slug: p.slug, artist_id: p.artist_id || "",
          category_id: p.category_id || "", price_azn: p.price_azn || 0,
          cover_url: p.cover_url || "", description: p.description || "",
          catalog_no: p.catalog_no || "", format: p.format || "",
          rpm: p.rpm || "", weight: p.weight || "",
          release_date: p.release_date || "", tracklist: p.tracklist || [],
          spotify_track_id: p.spotify_track_id || "", stock: p.stock || 10,
          featured: !!p.featured, limited: !!p.limited, new_arrival: !!p.new_arrival,
          created_at: serverTimestamp(), updated_at: serverTimestamp(),
        });
      }
    }
    if (await isEmpty("delivery_methods")) {
      for (const d of STATIC_DELIVERY) {
        await safeSet(["delivery_methods", d.id || d.code], {
          code: d.code, name: d.name, description: d.description || "",
          duration: d.duration || "", price_azn: d.price_azn || 0,
          icon: d.icon || "truck", active: true,
          created_at: serverTimestamp(),
        });
      }
    }
  } catch (_e) { /* never throw from seed */ }
}
